import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './ErrorBoundary';

// Guard against the classic React crash caused by in-page translation extensions
// (Google/Firefox Translate) and other scripts that move or delete DOM nodes React
// is managing — "Failed to execute 'removeChild'/'insertBefore' … not a child of
// this node". Normally React only ever removes its own children (child.parentNode
// === this), so this never fires; it only no-ops in the pathological case where an
// outside script already detached the node, turning a full-page white-screen into a
// harmless miss. Battle-tested workaround (facebook/react#11538). Especially
// important here: a multilingual audience means many visitors auto-translate.
if (typeof Node === 'function' && Node.prototype) {
  const _removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child && child.parentNode !== this) return child;
    return _removeChild.apply(this, arguments);
  };
  const _insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      // The reference node was moved/removed by an outside script. Rather than drop
      // newNode (leaving content missing), append it to this parent; React
      // reconciles to the correct order on its next render.
      try { return _insertBefore.call(this, newNode, null); } catch { return newNode; }
    }
    return _insertBefore.apply(this, arguments);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><ErrorBoundary><App /></ErrorBoundary></React.StrictMode>);
